module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0124.jpg?v=2235da63";